module.exports = __webpack_public_path__ + "static/img/31.eefa349.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/31.jpg
// module id = C6Lj
// module chunks = 1